import { render } from "./latest.vue?vue&type=template&id=651c1c42"
import script from "./latest.vue?vue&type=script&lang=js"
export * from "./latest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__